var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 1.04169C5.05049 1.04169 1.0415 5.05068 1.0415 10C1.0415 14.9494 5.05049 18.9584 9.99984 18.9584C14.9492 18.9584 18.9582 14.9494 18.9582 10C18.9582 5.05068 14.9492 1.04169 9.99984 1.04169ZM6.29654 10.3742L8.13202 12.402L13.7031 6.24726C13.9348 5.99135 14.33 5.97168 14.5859 6.20332C14.8418 6.43496 14.8615 6.8302 14.6299 7.08611L8.9043 13.4115L8.83106 13.4847C8.40455 13.8708 7.74582 13.838 7.35975 13.4115L5.36981 11.2131C5.13816 10.9572 5.15784 10.5619 5.41375 10.3303C5.66965 10.0987 6.06489 10.1183 6.29654 10.3742Z",
    fill: "#00E88F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13235 12.402L6.29686 10.3743C6.06522 10.1183 5.66998 10.0987 5.41408 10.3303C5.15817 10.562 5.13849 10.9572 5.37014 11.2131L7.36007 13.4115C7.74614 13.838 8.40488 13.8708 8.83139 13.4847L8.90462 13.4115L14.6302 7.08612C14.8618 6.83021 14.8422 6.43497 14.5863 6.20333C14.3303 5.97168 13.9351 5.99136 13.7035 6.24727L8.13235 12.402Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13235 12.402L6.29686 10.3743C6.06522 10.1183 5.66998 10.0987 5.41408 10.3303C5.15817 10.562 5.13849 10.9572 5.37014 11.2131L7.36007 13.4115C7.74614 13.838 8.40488 13.8708 8.83139 13.4847L8.90462 13.4115L14.6302 7.08612C14.8618 6.83021 14.8422 6.43497 14.5863 6.20333C14.3303 5.97168 13.9351 5.99136 13.7035 6.24727L8.13235 12.402Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/Correct.23e6c46b96f4d871a2799294efaf7b86.svg";
export { ForwardRef as ReactComponent };